module.exports = __webpack_public_path__ + "img/tab01.dc9375ae.png";